import {refreshUserToken} from '../helpers/refresh-user-token';
import {httpClient} from '../utils/shared/http-client';

const requestDomain = window.Site.commentsDomain;

const reactionsHttpRepositoryContract = Object.seal({
  async getCommonReactions() {
    throw Error('Method getCommonReactions() not implemented');
  },
  async getUserReactions() {
    throw Error('Method getUserReactions() not implemented');
  },
  async setUserReaction() {
    throw Error('Method setUserReaction() not implemented');
  },
  async deleteUserReaction () {
    throw Error('Method deleteUserReaction() not implemented');
  }
});

const reactionsHttpRepository = Object.assign(reactionsHttpRepositoryContract, {
  async getCommonReactions(articleId) {
    return await httpClient.get(`${requestDomain}articles/${articleId}/comments/reactions`);
  },
  async getUserReactions(articleId) {
    return await httpClient.authorizedGet(`${requestDomain}articles/${articleId}/comments/reactions/me`);
  },
  async setUserReaction (commentId, type) {
    await refreshUserToken(false);
    return await httpClient.post(`${requestDomain}comments/${commentId}/reactions`, null, {type}, false);
  },
  async deleteUserReaction (commentId) {
    return await httpClient.delete(`${requestDomain}comments/${commentId}/reactions`, null);
  }
});

export {
  reactionsHttpRepository
};
